import { Button, ErrorMessage, Icon, Text } from "@simplybusiness/mobius";
import { penToSquare } from "@simplybusiness/icons";
import { HelpLink } from "../../../../HelpLink";
import type { TradeQuestionSelectedProps } from ".";

export const TradeQuestionSelected = ({
  trade,
  onEditTrade,
  errorMessage,
}: TradeQuestionSelectedProps) => (
  <div className="mobius-trade-question--selected">
    <div className="mobius-trade-question__grid-container">
      <div className="mobius-trade-question__content">
        <Text
          elementType="p"
          className="mobius-trade-question__selected-text"
          data-testid="trade-selected-text"
        >
          You have selected ‘<strong>{trade.value}</strong>’ as your
          trade/profession.
        </Text>

        {trade?.definition && (
          <HelpLink
            headline="How do we define this type of business?"
            label="How do we define this type of business?"
            text={trade.definition}
          />
        )}
      </div>

      <Button
        className="mobius-question__help-link mobius-trade-question__edit-btn"
        onClick={onEditTrade}
        variant="link"
        size="sm"
        type="button"
        aria-label="Edit selected trade or profession"
      >
        <span>Edit</span>
        <Icon fixedWidth icon={penToSquare} size="sm" />
      </Button>
    </div>
    {errorMessage && <ErrorMessage errorMessage={errorMessage} />}
  </div>
);
